<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>Dewey decimal class</h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard</router-link>
                  \  Dewey decimal class
                </div>
              </div>
              <div class="breadcrumb-right" v-if="checkIsAccessible('library-dewey_decimal_class', 'create')">
                <div class="card-toolbar">
                  <v-btn @click="openCreateForm()" class="mt-4 btn btn-primary" style="color: #fff">
                    <v-icon small elevation="2" outlined>fas fa-plus</v-icon>&nbsp;
                    Add new
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body ">
            <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
              <div class="row">
                <div class="col-10">
                  <v-text-field id="title" clearable type="text" outlined dense v-model="search.name"   v-on:keyup.enter="getDeweyDecimalClass()"
                                label="Search by title"></v-text-field>
                </div>
                <v-col cols="2" md="2" class="text-right">
                  <v-btn
                      @click="getDeweyDecimalClass()"
                      class="btn btn-primary btn-search "
                      :loading="loading"
                  >
                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                    Search
                  </v-btn>
                </v-col>
<!--                <div class="col-2 ">
                  <v-btn dark @click="getDeweyDecimalClass()" class="btn btn-primary text-white">Search</v-btn>
                  <v-btn text @click="resetForm()" class="btn btn-standard cancel-btn ml-2">Reset</v-btn>
                  &lt;!&ndash;                  <button @click="reset()" class="btn btn-standard  ml-3">Reset</button>&ndash;&gt;
                </div>-->
              </div>
            </div>
            <div class="table-responsive ">
              <v-skeleton-loader
                  type="table-thead"
                  v-if="loading"
              >
              </v-skeleton-loader>

              <v-skeleton-loader
                  v-if="loading"
                  type="table-row-divider@25"
              >
              </v-skeleton-loader>
              <table class="table" v-if="!loading">
                <thead>
                <tr class="px-3">
                  <th>Title</th>
                  <th>Parent</th>
                  <th>Total</th>
                  <th class="pr-3 text-center">Action</th>
                </tr>

                </thead>
                <tbody class="text-left" v-if="classes.length>0">
                <tr v-for="(decimalClass, index) of classes" :key="index">
                  <td><span class="font-weight-black">{{ decimalClass.title }}</span>&nbsp;
                    <i class="mx-2 fas fa-circle"
                       :class="decimalClass.is_active?'dot-active':'dot-warning'"></i>
                  </td>

                  <td>
                    <span class="font-weight-medium">
                      {{ decimalClass.parent_title}}
                    </span>
                  <td>
                    <span class="font-weight-medium">
                    {{ decimalClass.total_children_count}}
                  </span>
                  </td>


                  <td class="pr-0 text-center">
                    <template>
                      <b-dropdown
                          size="sm"
                          variant="link"
                          toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                          no-caret
                          right
                          no-flip
                      >
                        <template v-slot:button-content>
                          <i class="ki ki-bold-more-hor"></i>
                        </template>
                        <div class="navi navi-hover min-w-md-250px">
                          <b-dropdown-text tag="div" class="navi-item"   v-if="checkIsAccessible('library-dewey_decimal_class', 'edit')">
                            <a @click="editDeweyDecimalClass(decimalClass.id)" class="navi-link">
                                <span class="navi-icon">
                                  <i class="fas fa-edit"></i>
                                </span>
                              <span class="navi-text">Edit</span>
                            </a>
                          </b-dropdown-text>
                          <b-dropdown-text tag="div" class="navi-item"  v-if="checkIsAccessible('library-dewey_decimal_class', 'delete')">
                            <a @click.prevent="deleteDeweyDecimalClass(decimalClass.id)" class="navi-link">
                                <span class="navi-icon">
                                     <i class="fas fa-trash red--text"></i>
                                </span>
                              <span class="navi-text">Delete</span>

                            </a>
                          </b-dropdown-text>

                        </div>
                      </b-dropdown>
                    </template>
                  </td>
                </tr>
                </tbody>
                <tbody class="text-left" v-if="classes.length == 0">
                <tr>
                  <td class="text-center" colspan="5">
                    <strong>Items not found.</strong>
                  </td>
                </tr>
                </tbody>
              </table>
              <b-pagination
                  v-if="classes.length > 0"
                  class="pull-right mt-7"
                  @input="getDeweyDecimalClass"
                  v-model="page"
                  :total-rows="total"
                  :per-page="perPage"
                  first-number
                  last-number
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <create-and-update ref="dewey-class" @close_dialog="closeDialog"></create-and-update>
  </v-app>
</template>
<script>
import DeweyDecimalClassService from "@/core/services/library/dewey-decimal-class/DeweyDecimalClassService";
import CreateAndUpdate from "@/view/pages/library/dewey-decimal-class/CreateAndUpdate";

const classService = new DeweyDecimalClassService();

export default {
  name: "Index",
  components: {CreateAndUpdate},
  data() {
    return {
      classes: [],
      page: 1,
      search: {
        name:""
      },
      total: null,
      perPage: null,
      loading:false,

    }
  },
  mounted() {
    this.getDeweyDecimalClass();
  },
  methods: {
    resetForm(){
      this.search = {
        name: ''
      }
      this.getDeweyDecimalClass()
    },
    getDeweyDecimalClass() {
      this.loading=true;
      classService.paginate(this.search, this.page).then(response => {
        this.classes = response.data.data
        this.page = response.data.meta.current_page;
        this.total = response.data.meta.total;
        this.perPage = response.data.meta.per_page;
      })
     .catch((err) => {
            console.log(err)
     })
      .finally(()=>{
            this.loading=false;
      });
    }, openCreateForm() {
      this.$refs['dewey-class'].showModal();
    }, closeDialog() {
      this.getDeweyDecimalClass()
      this.$refs['dewey-class'].hideModal();
    }, editDeweyDecimalClass(id) {
      this.$refs['dewey-class'].showModal(id);
    },
    deleteDeweyDecimalClass(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            classService.delete(id).then(response => {
              this.getDeweyDecimalClass();
            })
          }
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
